export function pageReady() {
    // Define context in that we are allowed to access data
    const chamberOfCommerce = document.getElementById('connection-chamber-of-commerce');

    // Global page-data
    let searchResults = [];
    let pageData = {info: null, company: null};

    document.getElementById('chamber-of-commerce-refresh-button')
        .addEventListener('click', async function () {
            await searchChamberOfCommerce();
        });

    // Get search data from KvK API -> only do request when length is 6 and only numbers have been entered
    async function searchChamberOfCommerce() {
        const input = chamberOfCommerce.getAttribute('data-commerce-number');
        const legalTypes = chamberOfCommerce.getAttribute('data-dd-legal-type-replace-values');

        if (input != null && input.length === 8 && onlyNumbers(input)) {
            // Do KvK API request
            await getDataFromApi(`/api/v1/kvk/search/${input}`, 'branch_number_error')
                .then(function (response) {
                    searchResults = response['data'];
                    // Set first item to selected
                    pageData['info'] = {
                        type : searchResults[0]['type'],
                        commerce_number : searchResults[0]['commerce_number'],
                        branch_number : searchResults[0]['location_number']
                    };
                    // Get first company with result
                    getCompanyDataFromChamberOfCommerce(0, 'branch_number_error');
                });
        }
    }

    // Get company data from KvK API -> Check if value has changed and is not caused by API call
    async function getCompanyDataFromChamberOfCommerce(location_index) {
        if (location_index != null && searchResults[location_index]['location_number'] != null) {
            // Update selected item to info of page
            pageData['info'] = {
                type : searchResults[location_index]['type'],
                commerce_number : searchResults[location_index]['commerce_number'],
                branch_number : searchResults[location_index]['location_number']
            };
            //  Prepare request url based on type of location
            // const api_url = searchResults[location_index]['type'] === 'rechtspersoon' ?
            //     `/api/v1/kvk/basic-profile/${searchResults[0]['commerce_number']}` :
            //     `/api/v1/kvk/branch-profile/${searchResults[0]['location_number']}`;
            // Do KvK API request
            await getDataFromApi(`/api/v1/kvk/basic-profile/${searchResults[0]['commerce_number']}`, 'address_error')
                .then(function (response) {
                    pageData['company'] = response['data'];
                    if (response['data']['addresses'] != null) {
                        replaceInputValues()
                    }
                });
        }
    }

    // Once an address has been selected update all found inputs with corresponding data
    function replaceInputValues(address_index) {
        // Get fields that we are allowed to replace
        const repFields = JSON.parse(chamberOfCommerce.getAttribute('data-replace-fields'));
        if (repFields != null && repFields.length >= 1) {
            repFields.forEach( function(field) {
                // If type is set we need to check which type of input we need to replace
                if (field['type'] != null && field['type'] === 'select') {
                    const legalTypes = JSON.parse(
                        chamberOfCommerce.getAttribute('data-dd-legal-type-replace-values')
                    );
                    const foundType = legalTypes.find(({ kvk_name }) => kvk_name === pageData['company']['legal_form']);

                    if (foundType != null) {
                        document.getElementById(field['input']).value = foundType['id'];
                        $(`#${field['input']}`).change();
                    }
                } else {
                    // Split full address_data to access house-number, add to street_name
                    let houseNumber = parseInt(splitAddressData(pageData['company']['addresses'][0]));
                    const splitFields = field['replace'].split(".");

                    let string = 'NaN';
                    switch (splitFields[0]) {
                        case "info":
                            string = pageData['info'][splitFields[1]];
                            break
                        case "address":
                            // Specific logic we need to do for some data
                            if (splitFields[1] === 'street_name') {
                                string = `${pageData['company']['addresses'][0]['street_name']} ${houseNumber}`;
                            } else if (splitFields[1] === 'number') {
                                string = houseNumber;
                            } else {
                                string = pageData['company']['addresses'][0][splitFields[1]];
                            }
                            break
                        case "company":
                            string = pageData['company'][splitFields[1]];
                            break
                    }

                    let formField = document.getElementById(field['input']);
                    if (formField != null) {
                        formField.value = string;
                    }
                }
            })
        }
    }

    async function getDataFromApi(request_url, on_error_show) {
        // Prepare for request by setting some items
        toggleSpinner(true);
        showError(null, on_error_show, false);
        // Start request
        return await axios.get(request_url).then(function (response) {
            toggleSpinner(false);
            if (response['data']['success'] != null && response['data']['success'] === true) {
                return response['data'];
            }
        }).catch(function (error) {
            toggleSpinner(false);
            showError(error, on_error_show, true);
        });
    }

    // Show occurred error in blade
    function showError(error, id, should_display) {
        const error_div = document.getElementById(id);
        if (error_div != null) {
            error_div.style.display = should_display === true ? 'block' : 'none';
        }
    }

    // Check if provided CommerceNumber is only numbers before doing request
    function onlyNumbers(str) {
        return /^[0-9]+$/.test(str);
    }

    // Toggle spinner from disabled / enabled
    function toggleSpinner(toggle) {
        setTimeout(function() {
            document.getElementById('chamber-of-commerce-refresh-button').disabled = toggle === true;
            document.getElementById('commerce_loading_spinner').style.display = toggle === true ? 'block' : 'none';
            document.getElementById('commerce_loading_text').style.display = toggle === true ? 'none' : 'block';
        }, toggle === false ? 800 : 0);
    }

    // Split address data into several items
    function splitAddressData(address_data) {
        return address_data['full_address']
            .replace(address_data['city'], '')
            .replace(address_data['postal_code'], '')
            .replace(address_data['street_name'], '')
            .replace(address_data['po_box_number'], '')
    }
}
